// extracted by mini-css-extract-plugin
export default {"language-button":"LanguageButton_language-button__6GIrp"};